import { Component, OnInit } from '@angular/core';
import { SurveyProductService } from "./survey-product.service";

const seccionRecuperada = (seccion) => seccion.listo == true;

@Component({
  selector: 'survey-product',
  templateUrl: './survey-product.component.html',
  // styleUrls: ['./survey-product.component.scss']
})
export class SurveyProductComponent implements OnInit {

  productoCertificar: any;
  tiposSecciones = [
    { tipo: 1, listo: false },
    { tipo: 2, listo: false },
    { tipo: 3, listo: false },
    { tipo: 4, listo: false },
    { tipo: 5, listo: false },
    { tipo: 6, listo: false },
    { tipo: 7, listo: false }
  ]; //tipos de secciones para cat master
  catalogo: any = [];
  surveyProduct: any;
  idiomas: any;
  catalogoRespReactivos: any;
  catalogoRespForall: any;
  catalogoDemograficos: any;
  catalogoIdiomasSurvey: any;
  infoTemplate: any;
  infoVoces: any;

  //productos con secciones editables y catálogo maestro
  productosPermitidos = ['c3','m7','p1','f1','am1','td1','pe1'];  //productos 3.0
  mensajeEntreComponents: string;

  constructor(
    private survProdSrv: SurveyProductService
  ) {

    this.survProdSrv.mensajeActual.subscribe( (resu) => {
      this.mensajeEntreComponents = resu;
      switch(this.mensajeEntreComponents){
        case "100":
        console.log('entro este visne yehahahahaha');
        this.reiniciaDatos();
        break;
      }
    });


  }

  ngOnInit() {
    // if(this.productosPermitidos.includes(localStorage.getItem('tipoProducto'))){
      console.log("tipo producto permitido:",localStorage.getItem('tipoProducto')," obtendrá el catalogo");

      this.catalogo = [];
      this.getCertificar();
      this.tiposSecciones.forEach((tipoSeccion,i) => {
        this.getCatalogoMaestro(tipoSeccion.tipo.toString(), i);
      });
    // }
    this.survProdSrv.recibidosPreguntasV3.subscribe((datos:any) => {
      console.log("orden recibida:",datos);
      if(datos.actualizarProducto == true){   //cuando recién se crea el surveyproduct entra esto
        console.log("se actualizarán datos del sp");
        this.reiniciaDatos();
        this.getCertificar();
        let esperaDatos = setInterval( () => {
          if(this.productoCertificar && this.surveyProduct && this.idiomas && this.catalogoRespReactivos && this.catalogoRespForall && this.catalogoDemograficos && this.catalogoIdiomasSurvey && this.infoTemplate){
            let datos = {
              productoCertificar: this.productoCertificar,
              surveyProduct: this.surveyProduct,
              idiomas: this.idiomas,
              catalogoRespReactivos: this.catalogoRespReactivos,
              catalogoRespForall: this.catalogoRespForall,
              catalogoDemograficos: this.catalogoDemograficos,
              catalogoIdiomasSurvey: this.catalogoIdiomasSurvey,
              infoTemplate: this.infoTemplate,
              actualizarProducto: true
            };
            console.log("envio de informacion a preguntas:",datos);
            this.survProdSrv.enviaDatosAPreguntasV3(datos);
            clearInterval(esperaDatos);
          }
        }, 0);
      }
      if(datos.recuperaInformacion == true){
        console.log("datosAEnviar:",{
          productoCertificar: this.productoCertificar,
          surveyProduct: this.surveyProduct,
          idiomas: this.idiomas,
          catalogoRespReactivos: this.catalogoRespReactivos,
          catalogoRespForall: this.catalogoRespForall,
          catalogoDemograficos: this.catalogoDemograficos,
          catalogoIdiomasSurvey: this.catalogoIdiomasSurvey,
          infoTemplate: this.infoTemplate,
          tiposSecciones: this.tiposSecciones,
          tiposSeccionesCompleto: this.tiposSecciones.every(seccionRecuperada)
        });

        let esperaDatos = setInterval( () => {
          if(this.productoCertificar && this.surveyProduct && this.idiomas && this.catalogoRespReactivos && this.catalogoRespForall && this.catalogoDemograficos && this.catalogoIdiomasSurvey && this.infoTemplate && this.tiposSecciones.every(seccionRecuperada)){
            let datos = {
              productoCertificar: this.productoCertificar,
              catalogo: this.catalogo,
              surveyProduct: this.surveyProduct,
              idiomas: this.idiomas,
              catalogoRespReactivos: this.catalogoRespReactivos,
              catalogoRespForall: this.catalogoRespForall,
              catalogoDemograficos: this.catalogoDemograficos,
              catalogoIdiomasSurvey: this.catalogoIdiomasSurvey,
              infoTemplate: this.infoTemplate,
              recuperaInformacion: true
            };
            console.log("envio de informacion a preguntas:",datos);
            this.survProdSrv.enviaDatosAPreguntasV3(datos);
            clearInterval(esperaDatos);
          }
        }, 0);
      }
      if(datos.actualizarCatalogo == true){
        this.catalogo = [];
        this.tiposSecciones.forEach(seccion => {
          seccion.listo = false;
        });
        this.tiposSecciones.forEach((tipoSeccion,i) => {
          this.getCatalogoMaestro(tipoSeccion.tipo.toString(), i);
        });
        let esperaDatos = setInterval( () => {
          if(this.tiposSecciones.every(seccionRecuperada)){
            let datos = {
              catalogo: this.catalogo,
              actualizarCatalogo: true
            };
            console.log("envio de informacion a preguntas:",datos);
            this.survProdSrv.enviaDatosAPreguntasV3(datos);
            clearInterval(esperaDatos);
          }
        }, 0);
      }
      if(datos.recuperaConfigVoces == true){
        console.log("configVoice");
        setTimeout(() => {
          const datos = {
            infoVoces: this.infoVoces,
            recuperaConfigVoces: true
          }
          this.survProdSrv.enviaDatosAPreguntasV3(datos);
        });
      }
    });
  }

  reiniciaDatos(){
    this.productoCertificar = null;
    // this.catalogo = [];
    this.surveyProduct = null;
    this.idiomas = null;
    this.infoTemplate = null;
    // this.catalogoRespReactivos = null;
    // this.catalogoRespForall = null;
    // this.catalogoDemograficos = null;
    // this.catalogoIdiomasSurvey = null;
  }

  getCertificar(){
    this.survProdSrv.getProdCertAct().subscribe((data:any) => {
      let prodsCertificar:any[] = data.productosCertificar;
      let indiceProducto = prodsCertificar.findIndex(item => item.fechaCertificar == parseInt(localStorage.getItem('fechaProducto')) && item.idCertificar == localStorage.getItem('productoID'));
      if(indiceProducto != -1){
        this.productoCertificar = prodsCertificar[indiceProducto];
        this.obtieneIdiomasGuardados();
        this.getSeccionesCuestionario();
        this.getFormVoices();
      }
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  obtieneIdiomasGuardados(){
    let datos:any= {productoId:this.productoCertificar.idCertificar};
    this.survProdSrv.getIdiomasProd(datos).subscribe( (data: any) => {
      this.idiomas = data.idiomasMostrar;
      if(!this.catalogoRespReactivos && !this.catalogoRespForall && !this.catalogoDemograficos && !this.catalogoIdiomasSurvey){
        this.getCatRespuestasReactivos();
        this.getCatDatosForAll();
        this.getCatDemograficos();
        this.getCatIdiomasSurvey();
      }
    });
  }
  getCatRespuestasReactivos(){
    this.survProdSrv.getCatRespuestasReactivos().subscribe((respuesta:any) => {
      console.log("getCatRespuestasReactivos",respuesta);
      this.catalogoRespReactivos = respuesta.answers;
    });
  }
  getCatDatosForAll(){
    this.survProdSrv.getCatDatosForAll().subscribe((respuesta:any) => {
      console.log("getCatForall",respuesta);
      this.catalogoRespForall = respuesta.questions;
    });
  }
  getCatDemograficos(){
    this.survProdSrv.getCatDemograficos().subscribe((respuesta:any) => {
      console.log("getCatDemograficos",respuesta);
      this.catalogoDemograficos = respuesta.demographics;
    });
  }
  getCatIdiomasSurvey(){
    this.survProdSrv.getCatIdiomasSurvey().subscribe((respuesta:any) => {
      console.log("getCatIdiomasSurvey",respuesta);
      this.catalogoIdiomasSurvey = respuesta.languages;
    });
  }

  getSeccionesCuestionario(){
    let datos:any= this.productoCertificar.surveyProductId._id;
    this.survProdSrv.getSeccionesCuestionario(datos).subscribe((respuesta:any) => {
      console.log("getSeccCuestionario:",respuesta);
      let esperaDatos = setInterval( () => {
        if(this.catalogoIdiomasSurvey){
          //repara idiomas faltantes a nombres de secciones
          let idiomaCorregido = false;
          respuesta.surveyproduct.sections.forEach(seccion => {
            if(seccion.sectionsLanguages.length < this.catalogoIdiomasSurvey.length){ //si no coincide el tamaño de idiomas, agrega los faltante
              this.catalogoIdiomasSurvey.forEach(idioma => {
                let indiceIdioma = seccion.sectionsLanguages.findIndex(item => item.lang == idioma.abbr);
                if(indiceIdioma == -1){ //si no se encuentra el idioma se agrega
                  seccion.sectionsLanguages.push({
                    textSection: "",
                    vivo: 1,
                    idLanguage: parseInt(idioma.idLanguage),
                    lang: idioma.abbr,
                    pendiente: true
                  });
                  idiomaCorregido = true;
                }
              });
            }
          });
          if(idiomaCorregido){
            respuesta.surveyproduct.broker= parseInt(localStorage.getItem('instituto_id')),
            this.survProdSrv.setSeccionesCuestionario(this.productoCertificar.surveyProductId._id, respuesta.surveyproduct).subscribe((respuesta:any) => {
              console.log("actualizaCuestionarioIdiomasFaltantes:",respuesta);
            });
          }
          this.surveyProduct = respuesta.surveyproduct;
          this.getInfoTemplate(respuesta.surveyproduct.templateId);
          clearInterval(esperaDatos);
        }
      }, 0);
    });
  }
  getCatalogoMaestro(tipoSeccion:string, indice:number){
    this.survProdSrv.getCatalogov2(localStorage.getItem('instituto_id'), tipoSeccion).subscribe((respuesta:any) => {
      // console.log("getCatalogo:",respuesta);
      this.tiposSecciones[indice].listo = true;
      this.catalogo.push(...respuesta.questions);
      if(this.tiposSecciones.every(seccionRecuperada)){
        console.log("todas el catalogo recuperado:", this.catalogo);
        console.log("tipos secciones consultadas:",this.tiposSecciones);

      }
    });
  }

  getInfoTemplate(templateId:string){
    this.survProdSrv.getTemplate(templateId).subscribe((respuesta:any) => {
      console.log("getTemplate:",respuesta);
      this.infoTemplate = respuesta.survey_template;
    })
  }

  getFormVoices(){
    this.infoVoces = {};
    this.survProdSrv.getFormVoices().subscribe((respuesta:any) => {
      if(respuesta.success){
        respuesta.voices.forEach(idioma => {
          if(this.infoVoces[idioma.claveIdioma] == undefined){
            this.infoVoces[idioma.claveIdioma] = idioma;
          }
        });
      }
    });
  }

}
